<template>
<div class="news-ticker-container">
      <h2 class="ticker-title">Latest Elections</h2>
      <div class="ticker-wrapper">
        <transition name="fade" mode="out-in">
          <div :key="currentIndex" class="news-list">
            <div 
              v-for="item in currentItems" 
              :key="item.id"
              @click="handleNewsClick(item)"
              class="news-item"
            >
              <img :src="logo" alt="Check Icon" class="check-icon" />
              <span class="news-title">{{ item.election }}</span>
              <svg class="arrow-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </div>
        </transition>
      </div>

     <!--
       <div class="pagination">
        <button
          v-for="(page, idx) in totalPages"
          :key="idx"
          @click="goToPage(idx)"
          :class="['page-dot', { active: idx === currentIndex }]"
          :aria-label="'Go to page ' + (idx + 1)"
        ></button>
      </div>
      -->
    </div>
</template>    
<script>
export default {
     props: {
    newsItems: {
      type: Array,
      required: true
    }
  },  
      data() {
      return {  
        logo:require('@/assets/logo.png'),
        currentIndex: 0,
        itemsPerPage: 4,
        interval: null,
       } 
      },
      computed: {
        totalPages() {
          return Math.ceil(this.newsItems.length / this.itemsPerPage);
        },
        currentItems() {
          const start = this.currentIndex * this.itemsPerPage;
          const end = start + this.itemsPerPage;
          return this.newsItems.slice(start, end);
        }
      },
      mounted() {
        this.startTicker();
      },
      beforeDestroy() {
        if (this.interval) {
          clearInterval(this.interval);
        }
      },
      methods: {
        startTicker() {
          this.interval = setInterval(() => {
            this.currentIndex = (this.currentIndex + 1) % this.totalPages;
          }, 12000);
        },
        goToPage(index) {
          this.currentIndex = index;
          clearInterval(this.interval);
          this.startTicker();
        },
        handleNewsClick(item) {
          console.log('Clicked:', item);
          this.$router.push({ name: 'election', params: { region: item.country } });
          // In your real app, use: this.$router.push(item.url);
        }
      }
    };
  </script>
<style scoped>
.news-ticker-container { width: 100%; max-width: 600px; margin: 0 auto; padding: 10px; border-radius: 12px;}
.ticker-title { font-size: 24px; font-weight: bold; color: #1f2937; margin-top: 16px; text-align: center; width: 100%;}
.icon { font-size: 28px; }
.ticker-wrapper { position: relative; overflow: hidden; border-radius: 8px; padding: 16px; min-height: 115px;}
.news-list {display: flex;flex-direction: column; gap: 12px;}
.news-item {display: flex;align-items: center;gap: 12px;padding: 12px;background: #f9fafb;border-radius: 8px;cursor: pointer;transition: all 0.3s ease;}
.news-item:hover {
      background: #dbeafe;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      transform: translateX(4px);
    }

    .check-icon {
      width: 20px;
      height: 20px;
      color: #2563eb;
      flex-shrink: 0;
      transition: transform 0.3s ease;
    }

    .news-item:hover .check-icon {
      transform: scale(1.1);
    }

    .news-title {
      flex: 1;
      color: #374151;
      font-weight: 500;
      transition: color 0.3s ease;
    }

    .news-item:hover .news-title {
      color: #1d4ed8;
    }

    .arrow-icon {
      width: 16px;
      height: 16px;
      color: #9ca3af;
      transition: all 0.3s ease;
    }

    .news-item:hover .arrow-icon {
      color: #2563eb;
      transform: translateX(4px);
    }

    .pagination {
      display: flex;
      justify-content: center;
      gap: 8px;
      margin-top: 16px;
    }

    .page-dot {
      width: 8px;
      height: 8px;
      border-radius: 9999px;
      background: #d1d5db;
      border: none;
      cursor: pointer;
      transition: all 0.3s ease;
      padding: 0;
    }

    .page-dot:hover {
      background: #9ca3af;
    }

    .page-dot.active {
      width: 24px;
      background: #2563eb;
    }

    .fade-enter-active, .fade-leave-active {
      transition: opacity 0.5s ease;
    }

    .fade-enter, .fade-leave-to {
      opacity: 0;
    }
  </style>